module.exports = __webpack_public_path__ + "img/favorite-unchecked.9ce70d5e.svg";